/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UsersService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List user names
     * @returns any User names
     * @throws ApiError
     */
    public getUserNames(): CancelablePromise<Array<{
        id: string;
        name: string;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/users/names',
        });
    }
    /**
     * Create a user
     * @returns any User created
     * @throws ApiError
     */
    public createUser({
        requestBody,
    }: {
        requestBody?: {
            name: string;
            pin: string;
        },
    }): CancelablePromise<{
        id: string;
        name: string;
        role: string;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/users',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * List users
     * @returns any Users
     * @throws ApiError
     */
    public getUsers(): CancelablePromise<Array<{
        id: string;
        name: string;
        role: string;
        failed_attempts: number;
        locked_until: string | null;
        created_at: string;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/users',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Delete a user
     * @returns any User deleted
     * @throws ApiError
     */
    public deleteUser({
        id,
    }: {
        id: string,
    }): CancelablePromise<{
        success: boolean;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }
    /**
     * Update a user's PIN
     * @returns any PIN updated
     * @throws ApiError
     */
    public updateUserPin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: {
            pin: string;
        },
    }): CancelablePromise<{
        success: boolean;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/users/{id}/pin',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }
    /**
     * Unlock a user
     * @returns any User unlocked
     * @throws ApiError
     */
    public unlockUser({
        id,
    }: {
        id: string,
    }): CancelablePromise<{
        success: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/users/{id}/unlock',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
            },
        });
    }
}
